import { computed } from 'vue'
import { useUserStore } from '@/stores/user'
import {
  selectEyeProtectionMode,
  tuEyeProtectionMode as fetchTuEyeProtectionMode
} from '@/api/user'

const THEME_LIGHT = 'theme'
const THEME_SOFT = 'theme1'

export function applyThemeAttribute(mode) {
  const isSoft = Number(mode) === 1
  document.documentElement.setAttribute('data-theme', isSoft ? THEME_SOFT : THEME_LIGHT)
}

/**
 * Soft Mode (eye-protection / dark UI) — aligned with Tutor.Web
 * html[data-theme="theme" | "theme1"]
 */
export function useTheme() {
  const userStore = useUserStore()
  const isSoftMode = computed(() => Number(userStore.isTuEyeProtectionMode) === 1)

  function applyLocal(mode) {
    const m = Number(mode) === 1 ? 1 : 0
    userStore.setTuEyeProtectionMode(m)
    applyThemeAttribute(m)
  }

  /** Load saved preference from API (shell mount / after login) */
  async function loadSoftMode() {
    try {
      // microSeviceFormatRequest → Body (0 | 1)
      const mode = await fetchTuEyeProtectionMode()
      applyLocal(mode)
      return Number(mode) === 1 ? 1 : 0
    } catch (e) {
      console.warn('loadSoftMode failed', e)
      applyLocal(userStore.isTuEyeProtectionMode)
      return Number(userStore.isTuEyeProtectionMode) === 1 ? 1 : 0
    }
  }

  /** Toggle Soft Mode and persist */
  async function setSoftMode(enabled) {
    const mode = enabled ? 1 : 0
    const res = await selectEyeProtectionMode(mode)
    if (res?.data && res.data.ErrorCode != null && res.data.ErrorCode !== 0) {
      throw new Error(res.data.Msg || 'Failed to switch Soft Mode')
    }
    applyLocal(mode)
    return mode
  }

  return {
    isSoftMode,
    applyLocal,
    loadSoftMode,
    setSoftMode
  }
}
